(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (() => {
    const rootSelector = '.trustz-filter-search-page';
    const gridSelector = '.tz-fs-el-products-grid';
    const controlSelector = '.tz-fs-el-load-more-products';
    let root;
    let grid;
    let sentinel;
    let observer;
    let scrollRoot;
    let loading = true;
    let hasMore = false;
    let receivedData = false;
    let frame = 0;

    function schedule() {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        sync();
        loadIfNear();
      });
    }

    function getScrollRoot() {
      for (let parent = grid?.parentElement; parent; parent = parent.parentElement) {
        if (/(auto|scroll|overlay)/.test(getComputedStyle(parent).overflowY)) {
          if (parent !== document.body && parent !== document.documentElement) return parent;
        }
      }
      return null;
    }

    function observe() {
      observer?.disconnect();
      scrollRoot = getScrollRoot();
      observer = new IntersectionObserver(schedule, {
        root: scrollRoot,
        rootMargin: '800px 0px',
      });
      if (sentinel?.isConnected && hasMore) observer.observe(sentinel);
    }

    function sync() {
      const nextRoot = document.querySelector(rootSelector);
      const nextGrid = nextRoot?.querySelector(gridSelector);
      if (!nextRoot || !nextGrid) {
        observer?.disconnect();
        return;
      }
      if (root !== nextRoot || grid !== nextGrid) {
        observer?.disconnect();
        sentinel?.remove();
        root = nextRoot;
        grid = nextGrid;
        sentinel = document.createElement('span');
        sentinel.dataset.lagniappeTrustzInfinite = '';
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.style.cssText = 'display:block;height:1px;width:100%;pointer-events:none';
        grid.after(sentinel);
        observe();
      }
      root.querySelectorAll(controlSelector).forEach((control) => {
        if (!receivedData && /^(block|flex|none)$/.test(control.style.display)) {
          hasMore = control.style.display !== 'none';
          loading = false;
        }
        const wrapper = control.parentElement;
        control.remove();
        if (wrapper?.classList.contains('tz-fs__loadmore_wrap') && !wrapper.children.length) {
          wrapper.remove();
        }
      });
      if (sentinel && !sentinel.isConnected) grid.after(sentinel);
      if (sentinel) {
        sentinel.dataset.state = loading ? 'loading' : hasMore ? 'ready' : 'complete';
        sentinel.toggleAttribute('hidden', !hasMore);
      }
      if (scrollRoot !== getScrollRoot()) observe();
      if (hasMore) observer?.observe(sentinel);
      else observer?.unobserve(sentinel);
    }

    function loadIfNear() {
      if (loading || !hasMore || !grid?.isConnected || !sentinel?.isConnected) return;
      const gridRect = grid.getBoundingClientRect();
      if (!gridRect.width || !gridRect.height) return;
      const rect = sentinel.getBoundingClientRect();
      const bounds = scrollRoot?.getBoundingClientRect();
      const bottom = bounds ? Math.min(bounds.bottom, window.innerHeight) : window.innerHeight;
      if (rect.top > bottom + 800) return;
      loading = true;
      sentinel.dataset.state = 'loading';
      window.postMessage({ type: 'FILTER_EVENT_LOAD_MORE_PRODUCT' }, window.location.origin);
    }

    window.addEventListener('message', (event) => {
      if (event.source !== window || event.origin !== window.location.origin) return;
      const data = event.data;
      if (!data || typeof data !== 'object') return;
      if (data.type === 'FILTER_SEARCH_PRODUCT_LOADING') {
        loading = true;
        schedule();
      } else if (data.type === 'FILTER_SEARCH_DATA') {
        receivedData = true;
        hasMore = data.hasMore === true;
        loading = false;
        schedule();
      } else if (
        /^FILTER_EVENT_(CHECKBOX|RADIO|BOX|SWATCH|RANGE_SLIDER|RANGE_SLIDER_PERCENT|SORT_BY|CLEAR|CLEAR_ALL)$/.test(data.type)
      ) {
        loading = true;
      }
    });

    function start() {
      const main = document.getElementById('MainContent');
      if (!main) return;
      new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
      document.addEventListener('scroll', schedule, { capture: true, passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      window.addEventListener('pageshow', schedule);
      schedule();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();


  } catch(e) { console.error(e); }
})();
})();
